export const uk = {
    'condition-type-all': 'Выполнены все',
    'condition-type-not': 'Не выполнено ни одного',
    'condition-type-or': 'Выполнено хотя бы одно',
    'day-description': {
        one: 'за {count} день',
        some: 'за {count} дня',
        many: 'за {count} дней',
        none: 'за {count} дней'
    },
    'no-metrika-goal-value': 'Цель не найдена',
    'no-segment-value': 'Сегмент не найден',
    'status-active': 'Активно',
    'status-stopped': 'Остановлено'
};
